class ImpactCountries extends HTMLElement {

  constructor() {
    super();
    this.initSlider();
  }

  initSlider() {
    const impactCountrySliderOptions = {
      container: this.querySelector('[data-slider]'),
      controls: true,
      nav: true,
      preventScrollOnTouch: 'auto',
      swipeAngle: 25,
      navPosition: 'bottom',
      mouseDrag: true,
      nextButton: this.querySelector('[data-slider-next]'),
      prevButton: this.querySelector('[data-slider-prev]')
    };
    tns(impactCountrySliderOptions);
  }
}
customElements.define('country-slider', ImpactCountries);

class TeamSlider extends HTMLElement {

  constructor() {
    super();
    this.initSlider();
  }

  initSlider() {
    const teamSliderOptions = {
      container: this.querySelector('[data-slider]'),
      nextButton: this.querySelector('[data-slider-next]'),
      prevButton: this.querySelector('[data-slider-prev]'),
      controls: true,
      nav: false,
      preventScrollOnTouch: 'auto',
      swipeAngle: 25,
      autoHeight: true,
      responsive: {
        768: {
          items: 2,
          gutter: 40,
          autoHeight: false,
        },
        992: {
          items: 3,
          gutter: 40,
        },
        1200: {
          gutter: 60,
        },
      },
    };
    tns(teamSliderOptions);
  }
}
customElements.define('team-slider', TeamSlider);